import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hyphen',
})
export class HyphenPipe implements PipeTransform {
  transform(value1: any, value2: any): string {
    if (value2) {
      return `${value1} - ${value2}`;
    } else {
      return value1;
    }
  }
}
